export const SCROLL_CONTAINER_ID = 'notifications-infiniteScroll';
